import { render } from "./SvgStar.vue?vue&type=template&id=b54fffda"
const script = {}

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__